export default __webpack_public_path__ + "static/media/code.948b85dc.jpg";